import { dateAndTimeConverter } from "./Constants";
import { ticketPillFor } from "../../Screens/Support/supportFormat";

export const supportTableHeadings = [
  {
    title: "SI.No",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "SUBJECT",
    width: "400px",
    textAlign: "left"
  },
  {
    title: "TICKET STATUS",
    width: "250px",
    textAlign: "left"
  },
  {
    title: "TICKET CODE",
    width: "200px",
    textAlign: "left"
  },
  {
    title: "FILED AT",
    width: "250px",
    textAlign: "right"
  }
];

export const supportTableField = (data) => {
  switch (data) {
    case "SI.No":
      return "serialNo";
    case "SUBJECT":
      return "name";
    case "TICKET STATUS":
      return "statusLabel";
    case "TICKET CODE":
      return "ticketCode";
    case "FILED AT":
      return "createdAt";
    default:
      return data?.toLowerCase();
  }
};

export function convertToSupportTableData(items) {
  const tableData = [];

  for (let i = 0; i < items.length; i++) {
    const ticket = items[i];
    tableData.push({
      ...ticket,
      serialNo: i + 1,
      documentId: ticket.workItemId,
      statusLabel: ticketPillFor(ticket, null).label,
      createdAt: `${dateAndTimeConverter(
        ticket?.createdAt,
        "Time"
      )}, ${dateAndTimeConverter(ticket?.createdAt, "thirdDate")}`
    });
  }
  return tableData;
}
